<template>
<div>
 <div class="modal-backdrop in" style=";z-index:99998"></div>
  <div class="modal-dialog"
       data-focus 
       style="z-index:99999;position:fixed;top:0;bottom:50px;right:0;left:0;display:flex; flex-flow:column nowrap;align-items:center;justify-content:center;align-content:center">   
    <div style=" display:flex; flex-flow:column nowrap;align-items:center;justify-content:center;align-content:center">
      <img style="width:120px" :src="PathGif">
      <div style="clear:both;height:50px">&nbsp;</div>
      <div class="progress progress-sm progress-striped active" style="width:700px" v-if="CurrentOggettoModalCaricamentoDati">
        <div class="progress-bar progress-bar-success" data-toggle="tooltip" data-original-title="30%" :style="{width: CurrentOggettoModalCaricamentoDati + '%'}"></div>
      </div>
      <div v-if="VisualizzaBottoneAnnulla">
        <div style="clear:both;height:10px">&nbsp;</div>
        <button class="btn btn-danger" @click="AnnullaCaricamentoDati" style="float:right;">&nbsp;&nbsp;&nbsp;&nbsp;Interrompi&nbsp;&nbsp;&nbsp;&nbsp;</button>
      </div>
    </div>
  </div>
</div>        
</template>

<script>
//Versione 1.2.0 - 08 Aprile 2025 - Mauro Brasile
//               - CHG: Tolta la classe modal-body dal div
//Versione 1.1.0 - 30 Maggio 2024 - Mauro Brasile
//               - NEW: Aggiunto pulsante Annulla per annullare le operazioni in corso
//Versione 1.0.0 - 16 Maggio 2024 - Mauro Brasile
//               - Prima Versione

export class TOggettoModalCaricamentoDati 
{
  constructor(DatoPassato, Width)
  {
    this.DatoPassato = DatoPassato
    this.Width       = Width
  }
}

export default 
{
  data()
  {
      return {}
  },

  emits: ['onClickAnnullaCaricamentoDati'],

  props : ['OggettoModalCaricamentoDati', 'PathGif', 'VisualizzaBottoneAnnulla'],
  
  computed :
  {
    CurrentOggettoModalCaricamentoDati :
    {
      get()
      {
        if(this.OggettoModalCaricamentoDati != undefined)
        {
          if(this.OggettoModalCaricamentoDati.DatoPassato)
            return this.OggettoModalCaricamentoDati.Width
        }
        return false
      }
    },

    CurrentFunctionAnnullaCaricamentoDati :
    {
      get()
      {
        return this.onClickAnnullaCaricamentoDati
      }
    }
  },

  methods :
  {
    AnnullaCaricamentoDati()
    {
      this.$emit('onClickAnnullaCaricamentoDati')
    },
  }
}
</script>
